import React, { useState, useEffect, useRef } from "react";
import $, { speed } from "jquery";
import BackButton from "./Backbutton";
import RippleInitializer from "./RippleInitializer";
import Title from "./Title";
import { useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";
import { motion } from "framer-motion";
const Datanew = [
  {
    id: 1,
    title: "Jab We Met",
    content:
      "It was love at first sight. If we could only control the time, We would go back to the moment when we both first met, not to change anything, but to experience it all over again!",
    img: "https://www.akamai.com/site/im-demo/perceptual-standard.jpg?imbypass=true",
    date: "Thrusday 27 Sep 19",


    memoryIcon
      :
      "1751961341186-@-0.webp"
  },
  {
    id: 2,
    title: "Jab We Met 1",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. In incidunt doloremque inventore? Culpa doloremque hic totam quaerat sequi fugiat sunt aperiam atque sapiente. Deserunt saepe quo molestias alias commodi quaerat!",
    img: "https://cdn.pixabay.com/photo/2024/01/02/14/58/leaf-8483401_640.jpg",
    date: "Thrusday 27 Sep 19",

    memoryIcon
      :
      "1751961341262-@-1.webp"
  },
  {
    id: 3,
    title: "Jab We Met 2",

    memoryIcon
      :
      "1751961341347-@-2.webp",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. In incidunt doloremque inventore? Culpa doloremque hic totam quaerat sequi fugiat sunt aperiam atque sapiente. Deserunt saepe quo molestias alias commodi quaerat!",
    img: "https://wallpapers.com/images/hd/hd-ocean-dock-50tgnxobumlsqssw.jpg",
    date: "Thrusday 27 Sep 19",
  },
  {
    id: 4,
    title: "Jab We Met",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. In incidunt doloremque inventore? Culpa doloremque hic totam quaerat sequi fugiat sunt aperiam atque sapiente. Deserunt saepe quo molestias alias commodi quaerat!",
    img: "https://cdn.pixabay.com/photo/2024/01/02/14/58/leaf-8483401_640.jpg",
    date: "Thrusday 27 Sep 19",

    memoryIcon
      :
      "1751961341428-@-3.webp"
  },
  {
    id: 5,
    title: "Jab We Met",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. In incidunt doloremque inventore? Culpa doloremque hic totam quaerat sequi fugiat sunt aperiam atque sapiente. Deserunt saepe quo molestias alias commodi quaerat!",
    img: "https://wallpapers.com/images/hd/hd-ocean-dock-50tgnxobumlsqssw.jpg",
    date: "Thrusday 27 Sep 19",
    memoryIcon
      :
      "1751961341502-@-4.webp"

  },
];
export const Memories = () => {
  const { id } = useParams();
  const [Data, setData] = useState(Datanew);
  const [activeSlide, setActiveSlide] = useState(0);
  const [showExitButton, setShowExitButton] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [heartImage, setHeartImage] = useState('');
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  const thirdslider = useRef(null);
  const mainSliderRef = useRef(null);
  const navSliderRef = useRef(null);
  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
  console.log(newImgUrl);
  useEffect(() => {
    const fetchMemories = async () => {
      try {
        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "Memories"
        });
        console.log(res);
        if (res) {
          setData(res.memories);

        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    };

    fetchMemories();
  }, [])
  useEffect(() => {
    if (Data.length > 0) {
      setHeartImage(newImgUrl + Data[0].memoryIcon);
    }
  }, [Data]);
  useEffect(() => {
    const $navSlider = $(navSliderRef.current);

    $navSlider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        if (nextSlide === slick.slideCount - 1) {
          setShowExitButton(true);
        } else {
          setShowExitButton(false);
        }
      }
    );
  }, [navSliderRef]);

  useEffect(() => {
    const $navSlider = $(navSliderRef.current);

    const handleInit = () => {
      $navSlider.find(".slick-prev").hide();
    };

    $navSlider.on("init", handleInit);

    return () => {
      $navSlider.off("init", handleInit);
    };
  }, [navSliderRef]);

  useEffect(() => {
    const $thirdslider = $(thirdslider.current);

    const handleInit = () => {
      $thirdslider.find(".slick-prev").hide();
    };

    $thirdslider.on("init", handleInit);

    return () => {
      $thirdslider.off("init", handleInit); // Cleanup on unmount
    };
  }, [thirdslider]);


  console.log(heartImage)

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    .joureney .slick-dots li.slick-active button:before {
 
      width: 30px !important;  /* same size */
      height: 30px !important; /* same size */

      padding: 0px !important; /* inner padding */
      background-origin: content-box !important; 
      background-clip: content-box !important;

      background: url('${heartImage}') no-repeat center center !important;
      background-size: contain !important;

      border: 2px solid #fff !important;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: white !important;

      transform: translate(-50%, -50%) scale(1.5);
      opacity: 1;
      transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
    }
  `;
    document.head.appendChild(style);

    return () => document.head.removeChild(style);
  }, [heartImage, Data]);

  useEffect(() => {
    if (Data.length === 0) return;
    const $mainSlider = $(mainSliderRef.current);
    const $navSlider = $(navSliderRef.current);
    $mainSlider.on("afterChange", function (event, slick, currentSlide) {
      setHeartImage(newImgUrl + Data[currentSlide].memoryIcon)
    });
    $mainSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: navSliderRef.current,
      dots: true,
      infinite: true,
    });

    $navSlider.slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      asNavFor: mainSliderRef.current,
      centerMode: true,
      variableWidth: true,
      swipe: false,
      touchMove: false,
      draggable: false,
      infinite: true,
      arrows: true,
    });

    setTimeout(() => {
      offsetDots(0);
    }, 0);

    function offsetDots(slideNum) {
      const $slickDots = $mainSlider.find(".slick-dots");
      const $dots = $slickDots.find("li");
      const dotWidth = $dots.first().outerWidth(true);
      const activeIndex = slideNum;
      setHeartImage(newImgUrl + Data[activeIndex].memoryIcon)
      $slickDots.css(
        "marginLeft",
        -activeIndex * dotWidth - Math.ceil(dotWidth / 1.2)
      );

      $dots.removeClass("slick-previous");
      $dots.each(function (index) {
        if (index < activeIndex) {
          $(this).addClass("slick-previous");
        }
      });
    }

    $mainSlider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        setHeartImage(newImgUrl + Data[currentSlide].memoryIcon)
        offsetDots(nextSlide);
      }
    );

    $navSlider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        const totalSlides = slick.slideCount;

        if (nextSlide === totalSlides - 1) {
          $navSlider.find(".slick-next").fadeOut(200);
        } else {
          $navSlider.find(".slick-next").fadeIn(200);
        }

        if (nextSlide !== 0) {
          $navSlider.find(".slick-prev").fadeIn(200);
        } else {
          $navSlider.find(".slick-prev").fadeOut(200);
        }
      }
    );




    // Trigger once to style immediately after initialization
    $mainSlider.trigger("init");

    return () => {
      $mainSlider.slick("unslick");
      $navSlider.slick("unslick");
    };
  }, [Data]);

  useEffect(() => {
    const $thirdslider = $(thirdslider.current);

    $thirdslider.slick({
      dots: true,
      fade: true,
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      slidesToScroll: 1,
      touchMove: false,
      swipe: false,
      afterChange: function (index) {
        console.log(
          `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
        );
      },
    });

    function offsetDots(slideNum) {
      const $slickDots = $thirdslider.find(".slick-dots");
      const numDots = $slickDots.find("li").length;
      const dotWidth = $slickDots.find("li:first").outerWidth(true);
      const offset = dotWidth * slideNum;

      $slickDots.css("marginLeft", offset * -1 - Math.ceil(dotWidth / 1.4));

      $slickDots.find("li").removeClass("slick-secondary");

      // Update previous dots
      const $dots = $slickDots.find("li");
      $dots.removeClass("slick-previous");

      $dots.each(function (index) {
        if (index < slideNum) {
          $(this).addClass("slick-previous");
        }
      });
    }

    $thirdslider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        $thirdslider
          .find(".slick-slide")
          .removeClass(
            "enteringFromBottom enteringFromTop leavingToBottom leavingToTop"
          );

        if (nextSlide > currentSlide) {
          $thirdslider
            .find(`.slick-slide[data-slick-index=${currentSlide}]`)
            .addClass("leavingToTop");
          $thirdslider
            .find(`.slick-slide[data-slick-index=${nextSlide}]`)
            .addClass("enteringFromBottom");
        } else {
          $thirdslider
            .find(`.slick-slide[data-slick-index=${currentSlide}]`)
            .addClass("leavingToBottom");
          $thirdslider
            .find(`.slick-slide[data-slick-index=${nextSlide}]`)
            .addClass("enteringFromTop");
        }
        setHeartImage(newImgUrl + Data[nextSlide].memoryIcon);
        setActiveIndex(nextSlide);
        offsetDots(nextSlide);
      }
    );

    // Handle slide animations
    $thirdslider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        $thirdslider
          .find(".slick-slide")
          .removeClass(
            "enteringFromBottom enteringFromTop leavingToBottom leavingToTop"
          );

        if (nextSlide > currentSlide) {
          $thirdslider
            .find(`.slick-slide[data-slick-index=${currentSlide}]`)
            .addClass("leavingToTop");
          $thirdslider
            .find(`.slick-slide[data-slick-index=${nextSlide}]`)
            .addClass("enteringFromBottom");
        } else {
          $thirdslider
            .find(`.slick-slide[data-slick-index=${currentSlide}]`)
            .addClass("leavingToBottom");
          $thirdslider
            .find(`.slick-slide[data-slick-index=${nextSlide}]`)
            .addClass("enteringFromTop");
        }

        setActiveIndex(nextSlide);
        offsetDots(nextSlide);

        // Handle visibility of navigation buttons immediately
        const totalSlides = slick.slideCount;

        if (nextSlide === totalSlides - 1) {
          $thirdslider.find(".slick-next").fadeOut(200); // Fade out over 200ms
        } else {
          $thirdslider.find(".slick-next").fadeIn(200); // Fade in over 200ms
        }

        if (nextSlide !== 0) {
          $thirdslider.find(".slick-prev").fadeIn(200); // Fade in over 200ms
        } else {
          $thirdslider.find(".slick-prev").fadeOut(200); // Fade out over 200ms
        }
      }
    );

    $thirdslider.on("init", function (event, slick) {
      offsetDots(0);
    });
    let startX = 0;
    let endX = 0;
    let isSwiping = false;

    const handleTouchStart = (event) => {
      startX = event.touches[0].clientX;
      isSwiping = false; // Reset swipe status
    };

    const handleTouchMove = (event) => {
      const moveX = event.touches[0].clientX;
      const deltaX = Math.abs(startX - moveX);

      if (deltaX > 10) {
        isSwiping = true;
        endX = moveX;
      }
    };

    const handleTouchEnd = () => {
      if (!isSwiping) return;

      const threshold = 50;
      const swipeDistance = startX - endX;

      if (swipeDistance > threshold) {
        $thirdslider.slick("slickNext");
      } else if (swipeDistance < -threshold) {
        $thirdslider.slick("slickPrev");
      }
    };

    // Attach custom touch event listeners
    $thirdslider.on("touchstart", handleTouchStart);
    $thirdslider.on("touchmove", handleTouchMove);
    $thirdslider.on("touchend", handleTouchEnd);

    return () => {
      $thirdslider.slick("unslick");
      // Clean up event listeners
      $thirdslider.off("touchstart", handleTouchStart);
      $thirdslider.off("touchmove", handleTouchMove);
      $thirdslider.off("touchend", handleTouchEnd);
    };
  }, []);

  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.3, // delay between each child animation
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <div className="flex w-full items-center bg-white joureney  overflow-hidden " >
      <RippleInitializer />

      <div className="flex-row flex-wrap grid grid-cols-12  col-md-12 justify-between items-center md:flex-row hideinmobile 100svh">
        <div
          className="w-full col-span-5  ourstoryfirst bg-black text-white  flex flex-col justify-center p-0 "
          style={{ height: "100svh" }}
        >
          <div
            className="flex flex-col justify-center items-center  ourstory "
            style={{ position: "relative", top: "10px", width: "auto" }}
          >
            <Title title={"Our Story"} pb={"pb-0"} />
          </div>
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="show"
          >
            <div
              className="main-slider firstsliderjoureny p-3 "
              ref={mainSliderRef}
            >

              {Data.map((data, index) => (
                <motion.div
                  key={index}
                  variants={itemVariants}>
                  <div className="SliderJoureny" key={index}>
                    <div className="relative isolate overflow-hidden bg-white py-4 rounded-3xl">
                      <div className="mx-auto max-w-7xl px-3 lg:px-8 flex flex-col justify-center items-center">
                        <div className="mx-auto max-w-2xl lg:mx-0 text-center flex justify-center flex-col items-center">
                          <div className="ourstoryheart ">
                            {data.memoryIcon && <img src={newImgUrl + data.memoryIcon} alt="" />}
                          </div>
                          <div
                            style={{ fontWeight: "600" }}
                            className="mt-3 mb-0 leading-8 text-black text-3xl pt-1 "
                          >
                            {data.memoryName}
                          </div>
                          <img
                            src="/img/ic_weddingline.svg"
                            className="ourstoryimg p-3 "
                            alt=""
                          />
                        </div>
                        <div className="mx-auto mt-0 max-w-2xl lg:mx-0 lg:max-w-none">
                          <div className="grid grid-cols-1 text-base font-semibold leading-7 text-black">
                            <div
                              style={{ fontWeight: "600", fontSize: "20px" }}
                              className="text-center"
                            >
                              {data.memoryDateTime}
                            </div>

                            <div
                              className="pb-0 mb-0 p-2   text-justify texcontent "
                              style={{
                                textAlign: "justify",
                                lineHeight: "30px",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                fontSize: "1rem",
                                WebkitLineClamp: 5,
                              }}
                            >
                              {data.memoryStory}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}

            </div>
          </motion.div>
        </div>
        <div
          className=" md:col-span-7 ourstorytwo "
          style={{ height: "100svh" }}
        >
          {showExitButton && (
            <div className="textfixed ">
              <BackButton style={{ height: "100% ", width: "100%" }}>
                <button className="buttonexit  ">Exit</button>
              </BackButton>
            </div>
          )}
          <div
            className="nav-slider "
            ref={navSliderRef}
            style={{ height: "100%" }}
          >
            {Data.map((data, index) => (
              <div
                className={`containerjourney    ${activeSlide === index ? "active " : ""
                  } ${index === Data.length - 1 ? "last-slider" : ""} ${activeSlide === 0 && activeSlide === index
                    ? "firstslideaslast"
                    : ""
                  }`}
                style={{
                  minHeight: "100svh",
                }}
                key={index}
              >
                <div className="blur-left "></div>
                <div className="blur-right "></div>

                <div className="">
                  {data.memoryImg && <img src={newImgUrl + data.memoryImg} style={{ minHeight: "100svh" }}
                    className={`
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                      }
									`}
                    onLoad={() => setIsImageLoaded(false)}
                    alt="" />}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className="hideinpc w-full "
        style={{ height: "100svh", maxHeight: "100svh", marginTop: "0px" }}
      >

        <div className="fixedtobottom">

          {Data.map((data, index) => (
            data.memoryImg && <img
              key={index}
              src={newImgUrl + data.memoryImg}
              alt=""

              className={` crossFade__image ${activeIndex === index ? 'crossFade__image--active' : ''
                }
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                }
									`}
              onLoad={() => setIsImageLoaded(false)}
            />
          ))}

          <div className="innderdivhidden">
            <div
              className="sliderhidden"
              style={{
                minHeight: "100svh",
                zIndex: "9999999999 ",
                position: "relative",
              }}
              ref={thirdslider}
            >
              {Data && Data.map((data, index) => (
                < div>
                  <div
                    style={{ bottom: "60px", position: "relative" }}
                    className="p-4 px-5 boxinner text-center d-flex flex-column align-items-center"
                  >
                    <div
                      className="p-1"
                      style={{ fontSize: "25px", fontWeight: "550" }}
                    >
                      {data.memoryName}
                    </div>
                    <div className="p-2">
                      <img
                        className="mobileversion "
                        style={{ position: "relative", height: "1.2rem" }}
                        src="/img/ic_weddingline.svg"
                        alt=""
                      />
                    </div>
                    <div
                      className="p-2"
                      style={{ fontSize: "25px", fontWeight: "550" }}
                    >
                      {data.memoryDateTime}
                    </div>
                    <div
                      className=" textinmobile"
                      style={{
                        textAlign: "justify",
                        textAlignLast: "left",
                        fontSize: "19px",
                      }}
                    >
                      {data.memoryStory}
                    </div>
                  </div>

                </div>
              ))}
            </div>
          </div>

          {/* Add Swipe text */}
          <div
            className={`swipe-text  textinmobile2  ${activeIndex === 0 ? "" : "hidden"
              }`}
            style={{ position: "absolute", bottom: 45, left: 25 }}
          >
            Swipe
          </div>
          {/* Add Exit text */}
          <div
            className={`exit-text textinmobile2 ${activeIndex === Data.length - 1 ? "" : "hidden"
              }`}
            style={{ position: "absolute", bottom: 45, right: 25 }}
          >
            <BackButton>Exit</BackButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Memories;
